import { useState } from "react";
import { HebrewDateFields, inputClass } from "@/components/calendar/HebrewDateFields";

const TYPES = [["aniversario", "Aniversario (matrimonio, etc.)"], ["especial", "Fecha especial"], ["fallecimiento", "Fallecimiento / iortzait"]];
const CALS = [["gregorian", "Calendario gregoriano"], ["hebrew", "Calendario hebreo"], ["both", "Ambos"]];

export function EventForm({ initial, people, onSave, onCancel, busy }) {
  const [ev, setEv] = useState(initial || { type: "aniversario", title: "", gdate: "", hdate: null, calendar: "gregorian", person_ids: [], notify: true });
  const [q, setQ] = useState("");
  const set = (k, v) => setEv((x) => ({ ...x, [k]: v }));
  const toggleP = (id) => set("person_ids", ev.person_ids.includes(id) ? ev.person_ids.filter((x) => x !== id) : [...ev.person_ids, id]);
  const matches = q ? people.filter((p) => p.name.toLowerCase().includes(q.toLowerCase())).slice(0, 6) : [];
  const submit = (e) => { e.preventDefault(); onSave({ ...ev, gdate: ev.gdate || null, hdate: ev.hdate?.day ? ev.hdate : null }); };
  return (
    <form onSubmit={submit} className="space-y-3" data-testid="cal-admin-event-form">
      <div className="grid sm:grid-cols-2 gap-3">
        <select data-testid="ef-type" value={ev.type} onChange={(e) => set("type", e.target.value)} className={inputClass}>
          {TYPES.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
        </select>
        <select data-testid="ef-calendar" value={ev.calendar} onChange={(e) => set("calendar", e.target.value)} className={inputClass}>
          {CALS.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
        </select>
      </div>
      <input required data-testid="ef-title" value={ev.title} onChange={(e) => set("title", e.target.value)} placeholder="Ej: Aniversario de Shlomo y Yael" className={inputClass} />
      <div className="grid sm:grid-cols-2 gap-3">
        <label className="text-xs text-cocoa-soft">Fecha gregoriana (año original)<input type="date" data-testid="ef-gdate" value={ev.gdate || ""} onChange={(e) => set("gdate", e.target.value)} className={`${inputClass} mt-1`} /></label>
        <div className="text-xs text-cocoa-soft">Fecha hebrea (opcional)<div className="mt-1"><HebrewDateFields value={ev.hdate} onChange={(v) => set("hdate", v)} testId="ef-hdate" /></div></div>
      </div>
      <div>
        <input data-testid="ef-person-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Agregar personas relacionadas…" className={inputClass} />
        {matches.length > 0 && (
          <div className="mt-1 rounded-xl border border-line bg-paper divide-y divide-line/60">
            {matches.map((p) => <button type="button" key={p.id} onClick={() => { toggleP(p.id); setQ(""); }} className="w-full text-left px-3 py-2 text-sm text-cocoa hover:bg-cream">{p.name}</button>)}
          </div>
        )}
        <div className="flex flex-wrap gap-1.5 mt-2">
          {ev.person_ids.map((id) => (
            <button type="button" key={id} onClick={() => toggleP(id)} className="rounded-full bg-night text-white text-xs px-3 py-1">
              {people.find((p) => p.id === id)?.name || id} ×
            </button>
          ))}
        </div>
      </div>
      <label className="inline-flex items-center gap-2 text-sm text-cocoa"><input type="checkbox" data-testid="ef-notify" checked={ev.notify} onChange={(e) => set("notify", e.target.checked)} /> Avisar a la familia ese día</label>
      <div className="flex gap-2 pt-2">
        <button data-testid="ef-save" disabled={busy} className="rounded-full bg-night text-white px-5 py-2.5 text-sm font-semibold cal-press disabled:opacity-50">Guardar</button>
        <button type="button" data-testid="ef-cancel" onClick={onCancel} className="rounded-full border border-line px-5 py-2.5 text-sm text-cocoa">Cancelar</button>
      </div>
    </form>
  );
}
